import React from 'react';
import CustomerDataProvider from '../contexts/CustomerDataProvider';
import {setPageTitle} from '../utils/helpers';
import MaturityInstructionForm from "../components/MaturityInstructionForm/MaturityInstructionForm";
import withFeatureFlags from "../components/FeatureFlags/withFeatureFlags";
import FocusedForm from "../layouts/FocusedForm/FocusedForm";
import '../components/MaturityInstructionForm/maturityInstructionForm.scss'

const MaturityInstructionPageContainer = () => {
    setPageTitle('Maturity Instruction | Investec Save');
    return (
        <CustomerDataProvider>
            <FocusedForm>
                <div className="text__navy">
                    <MaturityInstructionForm />
                </div>
            </FocusedForm>
        </CustomerDataProvider>
    );
};

export default withFeatureFlags(MaturityInstructionPageContainer);
